


















export default {
  data() {
    return {};
  },
  name: "NotFound",
  components: {},
};
